import {createFeatureSelector, createSelector} from "@ngrx/store";
import {IUserPermissionState} from "./permission.reducer";
import {permissionsConfigKey} from "./permissions.config";

export const userPermissionSelector = createFeatureSelector<IUserPermissionState>(permissionsConfigKey);
export const hasPermission = (permission:string) => createSelector(userPermissionSelector, state=> {
    return state?.userPermissions.some(y=>y.name === permission)
});

export const roles = createSelector(userPermissionSelector, state=>state.roles);